// extracted by mini-css-extract-plugin
export var root = "ucCD";